/**
 * @group Data
 * @summary Re-exports CONSULTATION_STATUS from @shared/constants for backward compatibility.
 */
export { CONSULTATION_STATUS } from '@shared/constants';
